import PropTypes from 'prop-types';
import { withProps } from 'recompose';
import { capitalizeFirst } from 'ramda-extension';
import { Field } from 'formik';
import cc from 'classcat';

import styles from './styles.module.scss';

/*
 * Note that formik merges its "form" object to the props, which we
 * do not want to pass to the <input>, as "form" is a valid <input>
 * attribute with a different meaning:
 *
 *  form_id:  "Specifies one or more forms the <input> element belongs to"
 *
 * If its value gets set to the formik object, essentially it is referring the
 * input to a non-existent form id, and thus enter-to-submit breaks, because it
 * no longer triggers the submit in the form the input is actually in.
 */
const SimplifiedInput = ({
  field,
  form,
  stacked,
  inlineError,
  inputClassName,
  className,
  ...props
}) => {
  const fieldName = field?.name;
  const error = form?.errors?.[fieldName];
  const touched = form?.touched?.[fieldName];

  return (
    <label
      className={cc([
        styles.container,
        {
          [styles.hasError]: !!error && !!touched && !inlineError,
          [styles.stacked]: stacked,
          [styles.notStacked]: !stacked,
        },
        className,
      ])}
    >
      <input
        {...props}
        {...field}
        className={cc([styles.input, inputClassName])}
      />
      {inlineError && !!error && !!touched && (
        <div className={styles.error}>{capitalizeFirst(error)}.</div>
      )}
    </label>
  );
};

SimplifiedInput.propTypes = {
  inlineError: PropTypes.bool,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  stacked: PropTypes.bool,
};

SimplifiedInput.defaultProps = {
  inlineError: true,
  stacked: true,
};

SimplifiedInput.displayName = 'SimplifiedInput';

export default SimplifiedInput;

export const FormikSimplifiedInput = withProps({
  component: SimplifiedInput,
})(Field);

FormikSimplifiedInput.displayName = 'FormikSimplifiedInput';
